import axios from 'axios';
import Cookies from 'js-cookie';
import { API } from '../lib/api';
import getAuthMode from '../getAuthMode';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/research';

function getCsrfToken() {
    return Cookies.get('csrftoken') || '';
}

const contactClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

contactClient.interceptors.request.use(
    (config) => {
        const csrfToken = getCsrfToken();
        if (csrfToken && ['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase())) {
            config.headers['X-CSRFToken'] = csrfToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export async function sendContactEmail(fullName, email, subject, message, captchaToken) {
  try {
    const response = await contactClient.post('/contact/', {
      fullName,
      email,
      subject,
      message,
      captchaToken,
    });
    return response.data;
  } catch (error) {
    console.error('sendContactEmail error:', error.response?.data || error.message);
    throw error;
  }
}

export default async function sendEmail(destinationEmail, subject, messageBody, authMode, captcha) {
  try {
    if (authMode === "Unauthorized") {
      return sendContactEmail('', '', subject, messageBody, captcha);
    }

    const normalizedEmail = (destinationEmail || "").trim().toLowerCase();

    if (normalizedEmail !== "") {
      const blacklistItemsQuery = await API.listBlacklist({ email: normalizedEmail });
      const blacklistItems = blacklistItemsQuery.data.getBlacklistsByEmail.items;

      if (blacklistItems.length === 0) {
        return sendContactEmail('Admin', normalizedEmail, subject, messageBody, captcha);
      }
    }
  } catch (err) {
    console.error(err);
    throw err;
  }
}